function nome_id({id=undefined,utenti=undefined,nome=undefined,nomeOnly=false}) {
    if (typeof id==="number"){
        for (let utente of utenti){
            if (utente["userid"]===id){
                if (!nomeOnly)
                return `${utente['name']} ${utente['surname']}`
                else return utente['name']
            }
        }
        return "Nessuno"
    }
    else {

        for (let utente of utenti){
            if (`${utente['name']} ${utente['surname']}`===nome){
                return utente["userid"]
            }
        }
        return 0
    }
}
export default nome_id